// AWS Cognito Configuration
const getRedirectUri = () => {
	const currentUrl = window.location.origin;
	if (currentUrl.includes("localhost:3000")) {
		return "http://localhost:3000/";
	} else if (
		currentUrl.includes("parts-planning.productionanalytics-dev.rio.cloud")
	) {
		return "https://parts-planning.productionanalytics-dev.rio.cloud/";
	} else if (
		currentUrl.includes(
			"parts-planning-development.productionanalytics-dev.rio.cloud",
		)
	) {
		return "https://parts-planning-development.productionanalytics-dev.rio.cloud/";
	}

	return currentUrl + "/"; // Fallback to current origin
};

const authConfig = {
	// User pool eu-west-1_9Z5g1z9ie ("User pool - bfraui", account 119806021746).
	// This is the pool whose app client has the dev/development/localhost
	// callback URLs registered, and the same pool the backend manages users in
	// (see backend routes/cognito_users.py USER_POOL_ID).
	cognitoDomain: "eu-west-19z5g1z9ie.auth.eu-west-1.amazoncognito.com",
	clientId: "6lg393pfqsmc963h2vcq2qch9q", // app client "My web app - parts tracking"
	redirectUri: getRedirectUri(), // Dynamic redirect URI based on current origins
};

export default authConfig;
